<template>
  <div :class="['balance-card', `balance-card--${tone}`]">
    <div class="balance-card__header">
      <p class="font-sm is-bold balance-card__label">
        {{ label }}
      </p>
      <span
        class="tag"
        :class="`is-${badgeTone}`"
      >{{ statusLabel }}</span>
    </div>
    <p class="balance-card__value">
      <span class="available font-ul is-bold">{{ available }}</span>
      <small class="font-sm">disponíveis</small>
    </p>
    <small class="font-sm balance-card__caption">
      Ganhe +{{ rechargePerSale }} consultas a cada venda
    </small>
  </div>
</template>
<script>
import { getBalanceTone } from '@/utils/balanceStatus';

const STATUS_LABEL = {
  normal: 'Disponível',
  atencao: 'Atenção',
  critico: 'Perto do limite',
  esgotado: 'Limite esgotado',
};

const STATUS_BADGE_TONE = {
  normal: 'success',
  atencao: 'warning',
  critico: 'danger',
  esgotado: 'danger',
};

export default {
  name: 'BalanceCard',
  props: {
    label: {
      type: String,
      required: true,
    },
    available: {
      type: Number,
      required: true,
    },
    rechargePerSale: {
      type: Number,
      required: true,
    },
  },
  computed: {
    tone() {
      return getBalanceTone(this.available);
    },
    statusLabel() {
      return STATUS_LABEL[this.tone];
    },
    badgeTone() {
      return STATUS_BADGE_TONE[this.tone];
    },
  },
};
</script>
<style lang="scss" scoped>
.balance-card {
  flex: 1;
  min-width: 45%;
  padding: 12px;
  border: 1px solid map.get($stone-types, "100");
  border-radius: 10px;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &--atencao {
    border-color: $amber-100;
  }

  &--critico {
    border-color: $red-200;
  }

  &--esgotado {
    border-color: map.get($stone-types, "200");
    background: map.get($stone-types, "50");
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
  }

  &__label {
    color: #666666;
  }

  &__value {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin-bottom: 8px;

    .available {
      color: black;
      font: 800 28px 'Inter';
      transition: color 0.2s ease;
    }
  }

  &--atencao &__value .available {
    color: #D97706;
  }

  &--critico &__value .available,
  &--esgotado &__value .available {
    color: $red-600;
  }

  &__caption {
    color: #666666;
  }
}
</style>
